













































































































































































































































































































































































































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Contact } from "@/api/models/contacts/contact";
import { Component, Vue, Ref, PropSync, Prop } from 'vue-property-decorator'
import { 
  BRow, 
  BCol, 
  BModal, 
  BFormGroup, 
  BFormInput, 
  BFormDatepicker,
  BFormTextarea,
  BButton,
  BFormFile,
  BListGroupItem,
  BListGroup
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { OpportuniteCreateModel } from "@/api/models/opportunites/opportunite";
import { Partenaire } from "@/api/models/partenaires/partenaire";
import { Fournisseur } from "@/api/models/fournisseurs/fournisseur";

@Component({
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    FormWizard,
    TabContent,
    ValidationObserver,
    ValidationProvider,
    SearchableVueSelect,
    BFormDatepicker,
    BFormTextarea,
    BButton,
    BFormFile,
    BListGroup,
    BListGroupItem
  }
})
export default class AddOpportunite extends Vue {
  @PropSync('isAddNewOpportuniteModalActive', { type: Boolean, default: false })
  isModalVisible!: boolean

  paginatedListContactsAcheteur: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListContactsDecisionnaire: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListUsers: PaginatedList<ShortUtilisateur> = new PaginatedList<ShortUtilisateur>();
  paginatedListPartenaires: PaginatedList<Partenaire> = new PaginatedList<Partenaire>();
  paginatedListFournisseurs: PaginatedList<Fournisseur> = new PaginatedList<Fournisseur>();

  listSourceOpportunites: {code: string, libelle: string}[] = []
  listTypeOpportunites: { code: string; libelle: string; }[] = [];
  listNatureOffres: { code: string; libelle: string; }[] = [];
  listTypePrestations: { code: string; libelle: string; }[] = [];
  listStatuts: { code: string; libelle: string; }[] = [];
  listRaisonsPerte: { code: string; libelle: string; }[] = [];
  listEntiteFacturation: { code: string; libelle: string; }[] = [];
  listNiveauConfiance: { code: string; libelle: string; }[] = [];
  listEcheancierFacturation: { code: string; libelle: string; }[] = [];
  listConditionPaiement: { code: string; libelle: string; }[] = [];
  listModelesSharepoint: { code: string; libelle: string; path: string }[] = [];

  opportunite: OpportuniteCreateModel = {}

  @Ref('step1Validator') readonly step1Validator!: InstanceType<typeof ValidationObserver>
  @Ref('step2Validator') readonly step2Validator!: InstanceType<typeof ValidationObserver>
  @Ref('step3Validator') readonly step3Validator!: InstanceType<typeof ValidationObserver>
  @Ref('step4Validator') readonly step4Validator!: InstanceType<typeof ValidationObserver>

  async created() {
    await this.loadSourceOpportunites()
    await this.loadTypeOpportunites()
    await this.loadNatureOffre()
    await this.loadTypePrestation()
    await this.loadStatuts()
    await this.loadRaisonsPerte()
    await this.loadEntiteFacturation()
    await this.loadNiveauConfiance()
    await this.loadEcheancierFacturation()
    await this.loadConditionPaiement()
    await this.loadModelesSharepoint()
  }

  async loadListContact(params: any): Promise<PaginatedList<Contact>> {
    var response = new PaginatedList<Contact>();
    await this.$http.myressif.entreprises
      .getListContactsByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? ""
      )
      .then((res: PaginatedList<Contact>) => {
        response = res;
      });

      return response;
  }

  async loadListContactAcheteur(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsAcheteur = new PaginatedList<Contact>();
    }

    var response = await this.loadListContact(params);

    this.paginatedListContactsAcheteur.items = this.paginatedListContactsAcheteur!.items.concat(
      response.items.filter(
        (ri) => !this.paginatedListContactsAcheteur!.items.some((lsi) => lsi.id == ri.id)
      )
    );
    this.paginatedListContactsAcheteur.hasNextPage = response.hasNextPage
    this.paginatedListContactsAcheteur.hasPreviousPage = response.hasPreviousPage
    this.paginatedListContactsAcheteur.pageIndex = response.pageIndex
    this.paginatedListContactsAcheteur.totalCount = response.totalCount
    this.paginatedListContactsAcheteur.totalPages = response.totalPages
  }

  async loadListContactDecisionnaire(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsDecisionnaire = new PaginatedList<Contact>();
    }

    var response = await this.loadListContact(params);

    this.paginatedListContactsDecisionnaire.items = this.paginatedListContactsDecisionnaire!.items.concat(
      response.items.filter(
        (ri) => !this.paginatedListContactsDecisionnaire!.items.some((lsi) => lsi.id == ri.id)
      )
    );
    this.paginatedListContactsDecisionnaire.hasNextPage = response.hasNextPage
    this.paginatedListContactsDecisionnaire.hasPreviousPage = response.hasPreviousPage
    this.paginatedListContactsDecisionnaire.pageIndex = response.pageIndex
    this.paginatedListContactsDecisionnaire.totalCount = response.totalCount
    this.paginatedListContactsDecisionnaire.totalPages = response.totalPages
  }

  async loadListPartenaires(params: any) {
    if (!params || params?.reset) {
      this.paginatedListPartenaires.items = this.paginatedListPartenaires?.items.filter(u => this.opportunite.partenaireId === u.id);
      this.paginatedListPartenaires.totalCount = this.paginatedListPartenaires.items.length;
    }

    await this.$http.myressif.partenaires
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Partenaire>) => {
        this.paginatedListPartenaires.items = this.paginatedListPartenaires!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListPartenaires!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListPartenaires.hasNextPage = response.hasNextPage
        this.paginatedListPartenaires.hasPreviousPage = response.hasPreviousPage
        this.paginatedListPartenaires.pageIndex = response.pageIndex
        this.paginatedListPartenaires.totalCount = response.totalCount
        this.paginatedListPartenaires.totalPages = response.totalPages
      });
  }

  async loadListFournisseurs(params: any) {
    if (!params || params?.reset) {
      this.paginatedListFournisseurs.items = this.paginatedListFournisseurs?.items.filter(u => this.opportunite.fournisseurId === u.id);
      this.paginatedListFournisseurs.totalCount = this.paginatedListFournisseurs.items.length;
    }

    await this.$http.myressif.fournisseurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Fournisseur>) => {
        this.paginatedListFournisseurs.items = this.paginatedListFournisseurs!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListFournisseurs!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListFournisseurs.hasNextPage = response.hasNextPage
        this.paginatedListFournisseurs.hasPreviousPage = response.hasPreviousPage
        this.paginatedListFournisseurs.pageIndex = response.pageIndex
        this.paginatedListFournisseurs.totalCount = response.totalCount
        this.paginatedListFournisseurs.totalPages = response.totalPages
      });
  }

  async loadUsers(params: any) {
    if (!params || params?.reset) {
      this.paginatedListUsers.items = this.paginatedListUsers?.items.filter(u => this.opportunite.responsableId === u.id);
      this.paginatedListUsers.totalCount = this.paginatedListUsers.items.length;
    }

    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.paginatedListUsers.items = this.paginatedListUsers!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListUsers!.items.some((lsi) => lsi.id == ri.id)
            )
          ).map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.paginatedListUsers.hasNextPage = response.hasNextPage
        this.paginatedListUsers.hasPreviousPage = response.hasPreviousPage
        this.paginatedListUsers.pageIndex = response.pageIndex
        this.paginatedListUsers.totalCount = response.totalCount
        this.paginatedListUsers.totalPages = response.totalPages
      });
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string, path: string}[]> {
    var response: {code: string, libelle: string, path: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  // paramètres
  async loadSourceOpportunites() {
    this.listSourceOpportunites = await this.loadParametre('opportunites_source_opportunite')
  }

  async loadTypeOpportunites() {
    this.listTypeOpportunites = await this.loadParametre('opportunites_type_opportunite')
  }

  async loadNatureOffre() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadTypePrestation() {
    this.listTypePrestations = await this.loadParametre('opportunites_type_prestation')
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  async loadRaisonsPerte() {
    this.listRaisonsPerte = await this.loadParametre('opportunites_raison_perte')
  }

  async loadEntiteFacturation() {
    this.listEntiteFacturation = await this.loadParametre('opportunites_entite_facturation')
  }

  async loadNiveauConfiance() {
    this.listNiveauConfiance = await this.loadParametre('opportunites_niveau_confiance')
  }

  async loadEcheancierFacturation() {
    this.listEcheancierFacturation = await this.loadParametre('opportunites_echeancier_facturation')
  }

  async loadConditionPaiement() {
    this.listConditionPaiement = await this.loadParametre('opportunites_condition_paiement')
  }

  async loadModelesSharepoint() {
    this.listModelesSharepoint = await this.loadParametre('opportunites_modeles_sharepoint')
  }

  // Validation de l'étape 1
  validateStep1(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step1Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  // Validation de l'étape 2
  validateStep2(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step2Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  // Validation de l'étape 3
  validateStep3(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step3Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  // Validation de l'étape 4
  validateStep4(): Promise<boolean> {
    return new Promise((resolve) => {
      this.step4Validator.validate().then((success) => {
        if (success) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  async onComplete() {
    await this.$http.myressif.entreprises
      .createOpportuniteOnEntreprise(this.$route.params.id, this.opportunite)
      .then(
        async (response: string) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'une opportunité",
            text: "Opportunité créée avec succès. Id de l'opportunité : " + response,
          });
          this.opportunite = {}
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );
    this.isModalVisible = false
    this.$emit('refetch-data')
  }

  refreshContacts() {
    this.loadListContactAcheteur({ reset: true, pageNumber: 1, pageSize: 10 })
    this.loadListContactDecisionnaire({ reset: true, pageNumber: 1, pageSize: 10 })
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }
}
